
export const CompaniesUsingNorseu = [
    "https://avatars.githubusercontent.com/u/69908664",
    "https://avatars.githubusercontent.com/u/65621284",
];